export const AUTH_LOGIN_TYPE = {
  PASSWORD: "password",
  OTP_CODE: "otp_code",
  OTP_HASH: "otp_hash"
};

export const AUTH_LOGIN_TYPE_BODY_KEY = "login-type";
